import { gql } from '@urql/core';
import React, { useMemo } from 'react';
import { GameIcon } from '../../icons/GameIcon';
import { HighSchoolOurEsportsCardFragment } from '../../../generated/spin-graphql';

type Props = {
    highSchool: HighSchoolOurEsportsCardFragment;
};

gql`
    fragment HighSchoolOurEsportsCard on espin_high_school {
        esportsTeams: teams(where: { deleted_at: { _is_null: true } }) {
            game {
                game_definition
                name
            }
        }
    }
`;

export const OurEsportsCard: React.FC<Props> = ({ highSchool }) => {
    const hsTeamGames = useMemo(() => {
        const teams = highSchool.esportsTeams || [];
        const uniqueGames = teams.filter(
            (team, index, self) =>
                index === self.findIndex((m) => m.game.game_definition === team.game.game_definition),
        );
        return uniqueGames.map((t) => t.game);
    }, [highSchool]);

    if (hsTeamGames.length === 0) {
        return <></>;
    }

    return (
        <div className="profile-card dark-theme">
            <div className="title-container">
                <h2 className="title">Our Esports Titles</h2>
                <div className="games">
                    {hsTeamGames.map((game, index: number) => (
                        <div className="game-container" key={`scholarship-link-${index}`}>
                            <GameIcon game={game.game_definition} gameName={game.name} className="college" />
                            {game.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
